// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__u3M2p","left":"Virtual_left__W6UP6","wrapper":"Virtual_wrapper__PCdNJ"};